<div class="with-floating-button">
    <div class="content">
        <page-header *ngIf="isDisplayed && !isOnErrorList"
                     [title]="'admin.frais.ndf.title' | translate"
                     [listeItems]="listeTabItems"
                     [selectedIndex]="selectedIndex"
                     (onSelectedItemChange)="onSelectedItemChange($event)">
        </page-header>
        <page-header *ngIf="isDisplayed && isOnErrorList"
                     [title]="'admin.frais.ndf.title' | translate"
                     [listeItems]="listeTabItems"
                     [selectedIndex]="selectedIndex"
                     (onSelectedItemChange)="onSelectedItemChange($event)"
                     (onGoBack)="goBack()">
        </page-header>

        <router-outlet></router-outlet>
    </div>
</div>
